/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import classes from "../../sales/manageCustomers/customers.module.css";
import Input from "../../../component/input";
import Grid from "@mui/material/Grid";
import Select from "../../../component/select";
import Checkbox from "@mui/material/Checkbox";
import stateCode from "../../../helper/stateCode";
import InputPhone from "../../../component/inputPhone";
import { withTranslation, Trans } from "react-i18next";

import FormControlLabel from "@mui/material/FormControlLabel";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddLocationIcon from "@mui/icons-material/AddLocation";

import Button from "@mui/material/Button";

import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import { Tab } from "@mui/material";
import AddressTable from "./addressTable";

class AddressDetails extends Component {
  state = {
    open: false,
  };

  componentDidMount() {
    this.props.addressList.map((address, i) => {
      address.open = false;
    });
  }

  setOpen = (value, index) => {
    this.props.addressList[index].open = value;
    this.setState({}, () => {});
  };

  //render
  render() {
    const { t } = this.props;
    return (
      <Grid container spacing={1}>
        <React.Fragment>
          <Box margin={1}></Box>
          <TableContainer>
            <Table size="small" aria-label="purchases">
              {this.props.addressList.map(
                (address, index) =>
                  address.attention &&
                  address.street1 &&
                  address.city && (
                    <>
                      <TableRow key={index} className={classes.root}>
                        <TableCell component="th" scope="row">
                          <LocationOnIcon /> {address.attention} :{" "}
                          {address.street1}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => this.setOpen(!address.open, index)}
                          >
                            {address.open ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
                          colSpan={6}
                        >
                          <Collapse in={address.open} timeout="auto">
                            <Box margin={1}>
                              <AddressTable
                                index={index}
                                isEdit={true}
                                attention={address.attention}
                                street1={address.street1}
                                street2={address.street1}
                                zip={address.zip}
                                phone={address.phone}
                                //addressValue={address}
                                country={this.props.country}
                                setAddress={this.props.setAddress}
                                hideAddressDetails={
                                  this.props.hideAddressDetails
                                }
                                createCustomerProfile={
                                  this.props.createCustomerProfile
                                }
                              />
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </>
                  ),
              )}
            </Table>
          </TableContainer>
        </React.Fragment>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AddressDetails));
